import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import { InfoDialog, Button, Query, PageContent } from 'components';
import COOKIES_PAGE_QUERY from 'queries/pages/cookies';
import persistor from 'utils/persistor';
import useCookieConsent from 'utils/cookieConsent';
import { useRouter } from 'next/router';

const AffiliateTermsDialog = ({ affiliate }) => {
    const [showCookiePolicy, setShowCookiePolicy] = useState(false);
    const [ , setCookieConsent ] = useCookieConsent();
    const router = useRouter();
    const acceptAffiliate = ({ allowTracking }) => {
        persistor.setAffiliateNetwork({ affiliate, value: router.query[affiliate.parameterName] });

        delete router.query[affiliate.parameterName];
        router.replace(
            {
                pathname: router.pathname,
                query: router.query,
            },
        );

        setCookieConsent(allowTracking);
    };

    const toggleShowCookiePolicy = () => setShowCookiePolicy(!showCookiePolicy);

    return (
        <InfoDialog
            className={ 'affiliateTermsDialog' }
            modal={ true }
            showClose={ false }
            modalContent={
                <>
                    <div className="text">
                        <Collapse in={ !showCookiePolicy }>
                            <h1>Vi minimerer dit digitale fodspor</h1>
                            <p>
                                Fordi du kommer fra en annoncepartner, er det nødvendigt at du accepterer at vi sætter en cookie,
                                sådan at vi kan afregne med partneren. Vi gør, hvad vi kan for at minimere dit
                                digitale fodspor. Derfor vil vi gerne have lov til at sætte en enkelt cookie yderligere. Den fortæller os,
                                om du har besøgt <Link href="/">penly.dk</Link> før.
                            </p>
                        </Collapse>
                        <p>
                            <Link href="#" onClick={ toggleShowCookiePolicy }>
                                { !showCookiePolicy ? 'Læs Penlys cookiepolitik' : 'Tilbage' } »
                            </Link>
                        </p>
                        <Collapse in={ showCookiePolicy }>
                            <Query query={ COOKIES_PAGE_QUERY }>
                                { ({ data: { cookiesPage } }) => <PageContent { ...cookiesPage.content } /> }
                            </Query>
                        </Collapse>
                    </div>
                </>
            }
            footerContent={
                <div className="buttonGroup">
                    <Button size="small" onClick={ () => acceptAffiliate({ allowTracking: false }) }>
                        Acceptér nødvendige
                    </Button>
                    <Button size="small" onClick={ () => acceptAffiliate({ allowTracking: true }) }>
                        Acceptér alle
                    </Button>
                </div>
            }
        />
    );
};

AffiliateTermsDialog.propTypes = {
    affiliate: PropTypes.object.isRequired,
};

export default AffiliateTermsDialog;
